import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider } from "@/context/AppContext";
import { LanguageProvider } from "@/i18n";
import Header from "@/components/Header";
import AuthCallback from "@/components/AuthCallback";
import AccessGate from "@/components/AccessGate";
import Home from "@/pages/Home";
import LessonBrowse from "@/pages/LessonBrowse";
import LessonReader from "@/pages/LessonReader";
import Flashcards from "@/pages/Flashcards";
import { QuizHub, QuizRunner } from "@/pages/Quizzes";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import PracticeHub from "@/pages/PracticeHub";
import MatchGame from "@/pages/MatchGame";
import SentenceBuilder from "@/pages/SentenceBuilder";
import Listening from "@/pages/Listening";
import Culture from "@/pages/Culture";
import Grammar from "@/pages/Grammar";
import PictureDictionary from "@/pages/PictureDictionary";

function Shell() {
  const location = useLocation();

  // Detect OAuth session_id in URL fragment synchronously (prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/learn" element={<AccessGate><LessonBrowse /></AccessGate>} />
          <Route path="/lesson/:id" element={<AccessGate><LessonReader /></AccessGate>} />
          <Route path="/flashcards" element={<AccessGate><Flashcards /></AccessGate>} />
          <Route path="/quizzes" element={<AccessGate><QuizHub /></AccessGate>} />
          <Route path="/quizzes/:lessonId" element={<AccessGate><QuizRunner /></AccessGate>} />
          <Route path="/practice" element={<AccessGate><PracticeHub /></AccessGate>} />
          <Route path="/practice/match" element={<AccessGate><MatchGame /></AccessGate>} />
          <Route path="/practice/build" element={<AccessGate><SentenceBuilder /></AccessGate>} />
          <Route path="/practice/listen" element={<AccessGate><Listening /></AccessGate>} />
          <Route path="/culture" element={<AccessGate><Culture /></AccessGate>} />
          <Route path="/grammar" element={<AccessGate><Grammar /></AccessGate>} />
          <Route path="/dictionary" element={<AccessGate><PictureDictionary /></AccessGate>} />
          <Route path="/dashboard" element={<AccessGate><Dashboard /></AccessGate>} />
          <Route path="/admin" element={<AccessGate adminOnly><Admin /></AccessGate>} />
        </Routes>
      </main>
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[#F9F8F5]">
      <BrowserRouter>
        <LanguageProvider>
          <AppProvider>
            <Shell />
            <Toaster position="top-center" richColors />
          </AppProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
